module.exports = __webpack_public_path__ + "media/images/categories/icon_cat19-1298d7e8019de7a05f625a761b8830fa.svg";